export class ValidatedIBAN {
  name: string;
  iban: string;
  bic: string;
  message: string;
  valid = true;
}
